import { useFetch } from '@reveni-io/reveni-ui'

import { pageSize } from './constants'

const useAdditionalCriteriaSelector = ({ storeId, getCriteriaService }) => {
  const { data, loading } = useFetch(getCriteriaService, {
    doInitialRequest: !!storeId,
    params: { storeId, page: 1, pageSize },
  })

  return {
    availabilityCriteria: data?.results || [],
    loading,
  }
}

export default useAdditionalCriteriaSelector
